var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-tool-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8917 43.5706L13.1005 46.6889C9.87982 47.2869 8.26951 47.5859 7.34182 46.6582C6.41412 45.7303 6.71314 44.12 7.31121 40.8992L10.4293 24.1072C10.9293 21.4146 11.1793 20.0683 12.0668 19.2548C12.9543 18.4414 14.5775 18.2826 17.8238 17.9651C20.9526 17.6591 23.9137 16.5865 27 13.5L40.5 27.0011C37.4137 30.0877 36.3404 33.0467 36.034 36.1757C35.716 39.4225 35.557 41.0458 34.7436 41.9332C33.9302 42.8206 32.584 43.0706 29.8917 43.5706Z",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.75 34.2236C23.4911 34.0193 22.3401 33.4717 21.4342 32.5658M21.4342 32.5658C20.5283 31.66 19.9807 30.5089 19.7763 29.25M21.4342 32.5658L9 45",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27 13.5C28.6027 11.1355 30.7735 7.1577 33.9896 6.77471C36.1849 6.51328 38.0039 8.33202 41.6412 11.9695L42.0305 12.3587C45.668 15.9962 47.4867 17.815 47.2253 20.0104C46.8423 23.2265 42.8645 25.3973 40.5 27",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.7530dfbed60daca195f0ef87cb2eb268.svg";
export { ForwardRef as ReactComponent };